import { render, staticRenderFns } from "./HomePlans.vue?vue&type=template&id=e0643afc&scoped=true&"
import script from "./HomePlans.vue?vue&type=script&lang=js&"
export * from "./HomePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0643afc",
  null
  
)

export default component.exports